var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulldozer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 3C3.44772 3 3 3.44772 3 4V11.2676C2.4022 11.6134 2 12.2597 2 13V15.9364C2.74811 14.4892 4.25853 13.5 6 13.5H11C13.4853 13.5 15.5 15.5147 15.5 18C15.5 18.7184 15.3316 19.3975 15.0322 20H21C21.5523 20 22 19.5523 22 19V18.7808C22 18.3219 21.6877 17.9219 21.2425 17.8106L18 17L17.09 7.9005C17.0389 7.38929 16.6088 7 16.095 7H16C15.4477 7 15 7.44772 15 8V11H14V4C14 3.44772 13.5523 3 13 3H4ZM5 5H12V10H5V5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 18C3 16.3431 4.34315 15 6 15H11C12.6569 15 14 16.3431 14 18C14 19.6569 12.6569 21 11 21H6C4.34315 21 3 19.6569 3 18ZM7.5 18C7.5 17.1716 6.82843 16.5 6 16.5C5.17157 16.5 4.5 17.1716 4.5 18C4.5 18.8284 5.17157 19.5 6 19.5C6.82843 19.5 7.5 18.8284 7.5 18ZM11 19.5C11.8284 19.5 12.5 18.8284 12.5 18C12.5 17.1716 11.8284 16.5 11 16.5C10.1716 16.5 9.5 17.1716 9.5 18C9.5 18.8284 10.1716 19.5 11 19.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulldozer);
export default __webpack_public_path__ + "static/media/bulldozer.6b16a312c43a62d1ecc173f42d319dda.svg";
export { ForwardRef as ReactComponent };